import { all } from 'redux-saga/effects';
import BasicDetailsSaga from './BasicDetailsSaga';
import PowerPositionSaga from './PowerPositionSaga';
import salesRepClassificationsaga from './salesRepClassificationSaga';
import NegotiationActionsSaga from './NegotiationActionsSaga';
import profileDetailsSaga from './profileDetailsSaga';
import { dashboardSaga } from './dashboardSaga';
import { DocumentOutcomeSaga } from './DocumentOutcomeSaga';
import { CloseNegotiationSaga } from './closeNegotiationSaga';

export default function* rootSaga(): Generator {
    yield all([
        yield *BasicDetailsSaga(),
        yield *NegotiationActionsSaga(),
        yield *PowerPositionSaga(),
        yield *salesRepClassificationsaga(),
        yield* profileDetailsSaga(),
        yield* dashboardSaga(),
        yield* DocumentOutcomeSaga(),
        yield* CloseNegotiationSaga()
    ])
}